import { render, staticRenderFns } from "./proprietarioFrotaReportModel.vue?vue&type=template&id=311ea02a&scoped=true"
import script from "./proprietarioFrotaReportModel.vue?vue&type=script&lang=js"
export * from "./proprietarioFrotaReportModel.vue?vue&type=script&lang=js"
import style0 from "./proprietarioFrotaReportModel.vue?vue&type=style&index=0&id=311ea02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ea02a",
  null
  
)

export default component.exports